export default __webpack_public_path__ + "static/background-22db540973494aa1fb949d10c14303b6.png";